import React from 'react'

const Hardware = () => {
  return (
    <div>Hardware</div>
  )
}

export default Hardware